/** Kannada: price drivers, their chips, and what an estimate says about itself. */
export const drivers = {
    "question.surface": "ಒಳಗಿನ ಗೋಡೆಗಳು, ಹೊರಗಿನವು, ಅಥವಾ ಎರಡೂ?",
    "question.floors": "ಎಷ್ಟು ಮಹಡಿಗಳು?",
    "question.house_type": "ಫ್ಲ್ಯಾಟ್, ಸ್ವತಂತ್ರ ಮನೆ ಅಥವಾ ವಿಲ್ಲಾ?",
    "question.finish": "ಸಾದಾ ಪೇಂಟ್ ಅಥವಾ ಟೆಕ್ಸ್ಚರ್?",
    "question.days_week": "ವಾರಕ್ಕೆ ಎಷ್ಟು ದಿನ?",
    "question.tasks": "ಯಾವ ಕೆಲಸ: ಗುಡಿಸುವುದು ಒರೆಸುವುದು, ಪಾತ್ರೆ ಸಹಿತ, ಅಥವಾ ಇಡೀ ಮನೆ?",
    "question.vehicle": "ಯಾವ ಕಾರು: ಹ್ಯಾಚ್‌ಬ್ಯಾಕ್, ಸೆಡಾನ್ ಅಥವಾ ಎಸ್‌ಯುವಿ?",
    "question.points": "ಎಷ್ಟು ಪಾಯಿಂಟ್‌ಗಳು (ಸ್ವಿಚ್, ನಲ್ಲಿ, ಬಾಗಿಲು ಅಥವಾ ಯೂನಿಟ್)?",
    "detail.surface": "ಗೋಡೆಗಳು",
    "detail.floors": "ಮಹಡಿಗಳು",
    "detail.house_type": "ಮನೆಯ ಬಗೆ",
    "detail.finish": "ಫಿನಿಶ್",
    "detail.days_week": "ವಾರಕ್ಕೆ ದಿನಗಳು",
    "detail.tasks": "ಕೆಲಸಗಳು",
    "detail.vehicle": "ಕಾರು",
    "detail.points": "ಪಾಯಿಂಟ್‌ಗಳು",
    "driver.ask.area_sqft": "ಮನೆ ಸುಮಾರು ಎಷ್ಟು ಚದರ ಅಡಿ?",
    "driver.ask.rooms": "ಎಷ್ಟು ಬೆಡ್‌ರೂಮ್ (ಬಿಎಚ್‌ಕೆ)?",
    "driver.ask.surface": "ಒಳಗಿನ ಗೋಡೆಗಳು, ಹೊರಗಿನವು, ಅಥವಾ ಎರಡೂ?",
    "driver.ask.floors": "ಎಷ್ಟು ಮಹಡಿಗಳು?",
    "driver.ask.house_type": "ಫ್ಲ್ಯಾಟ್, ಸ್ವತಂತ್ರ ಮನೆ ಅಥವಾ ವಿಲ್ಲಾ?",
    "driver.ask.paint_by": "ಪೇಂಟ್ ನೀವೇ ಕೊಳ್ಳುವಿರಾ, ಅಥವಾ ಪೇಂಟರ್ ತರಬೇಕೇ?",
    "driver.ask.finish": "ಸಾದಾ ಪೇಂಟ್ ಅಥವಾ ಟೆಕ್ಸ್ಚರ್?",
    "driver.ask.people": "ಎಷ್ಟು ಜನರಿಗೆ ಅಡುಗೆ?",
    "driver.ask.meals": "ದಿನಕ್ಕೆ ಎಷ್ಟು ಹೊತ್ತು ಊಟ?",
    "driver.ask.days_week": "ವಾರಕ್ಕೆ ಎಷ್ಟು ದಿನ?",
    "driver.ask.frequency": "ಎಷ್ಟು ಸಲ ಬರಬೇಕು?",
    "driver.ask.tasks": "ಯಾವ ಕೆಲಸ: ಗುಡಿಸುವುದು ಒರೆಸುವುದು, ಪಾತ್ರೆ ಸಹಿತ, ಅಥವಾ ಇಡೀ ಮನೆ?",
    "driver.ask.hours": "ದಿನಕ್ಕೆ ಎಷ್ಟು ಗಂಟೆ?",
    "driver.ask.vehicle": "ಯಾವ ಕಾರು: ಹ್ಯಾಚ್‌ಬ್ಯಾಕ್, ಸೆಡಾನ್ ಅಥವಾ ಎಸ್‌ಯುವಿ?",
    "driver.ask.problem": "ಕೆಲಸ ಏನು?",
    "driver.ask.points": "ಎಷ್ಟು ಪಾಯಿಂಟ್‌ಗಳು (ಸ್ವಿಚ್, ನಲ್ಲಿ, ಬಾಗಿಲು ಅಥವಾ ಯೂನಿಟ್)?",
    "driver.ask.points.electrician": "ಎಷ್ಟು ಸ್ವಿಚ್, ಸಾಕೆಟ್ ಅಥವಾ ಫಿಟ್ಟಿಂಗ್?",
    "driver.ask.points.plumber": "ಎಷ್ಟು ನಲ್ಲಿ, ಪೈಪ್ ಅಥವಾ ಫಿಟ್ಟಿಂಗ್?",
    "driver.ask.points.carpenter": "ಎಷ್ಟು ವಸ್ತು, ಬಾಗಿಲು ಅಥವಾ ಫಿಟ್ಟಿಂಗ್?",
    "driver.ask.points.ac_technician": "ಎಷ್ಟು ಎಸಿ ಯೂನಿಟ್?",
    "driver.value.surface.inside": "ಒಳಗೆ",
    "driver.value.surface.outside": "ಹೊರಗೆ",
    "driver.value.surface.both": "ಎರಡೂ",
    "driver.value.house_type.flat": "ಫ್ಲ್ಯಾಟ್",
    "driver.value.house_type.independent": "ಸ್ವತಂತ್ರ ಮನೆ",
    "driver.value.house_type.villa": "ವಿಲ್ಲಾ",
    "driver.value.paint_by.household": "ನಾನೇ ಕೊಳ್ಳುತ್ತೇನೆ",
    "driver.value.paint_by.worker": "ಪೇಂಟರ್ ತರಲಿ",
    "driver.value.finish.plain": "ಸಾದಾ",
    "driver.value.finish.texture": "ಟೆಕ್ಸ್ಚರ್",
    "driver.value.frequency.daily": "ಪ್ರತಿದಿನ",
    "driver.value.frequency.alternate_days": "ದಿನ ಬಿಟ್ಟು ದಿನ",
    "driver.value.frequency.weekly": "ವಾರಕ್ಕೊಮ್ಮೆ",
    "driver.value.tasks.sweep_mop": "ಗುಡಿಸುವುದು ಒರೆಸುವುದು",
    "driver.value.tasks.sweep_mop_dishes": "ಪಾತ್ರೆ ಸಹಿತ",
    "driver.value.tasks.full": "ಇಡೀ ಮನೆ",
    "driver.value.vehicle.hatchback": "ಹ್ಯಾಚ್‌ಬ್ಯಾಕ್",
    "driver.value.vehicle.sedan": "ಸೆಡಾನ್",
    "driver.value.vehicle.suv": "ಎಸ್‌ಯುವಿ",
    "driver.value.problem.fan": "ಫ್ಯಾನ್",
    "driver.value.problem.switch": "ಸ್ವಿಚ್",
    "driver.value.problem.light": "ಲೈಟ್",
    "driver.value.problem.wiring": "ವೈರಿಂಗ್",
    "driver.value.problem.leak": "ಸೋರಿಕೆ",
    "driver.value.problem.tap": "ನಲ್ಲಿ",
    "driver.value.problem.blockage": "ಕಟ್ಟಿಕೊಂಡಿದೆ",
    "driver.value.problem.toilet": "ಟಾಯ್ಲೆಟ್",
    "driver.value.problem.door": "ಬಾಗಿಲು",
    "driver.value.problem.repair": "ರಿಪೇರಿ",
    "driver.value.problem.assembly": "ಪೀಠೋಪಕರಣ ಜೋಡಣೆ",
    "driver.value.problem.service": "ಸರ್ವೀಸ್",
    "driver.value.problem.gas_refill": "ಗ್ಯಾಸ್ ತುಂಬಿಸುವುದು",
    "driver.value.problem.install": "ಅಳವಡಿಕೆ",
    "driver.value.problem.other": "ಬೇರೆ ಏನೋ",
    "driver.n.area_sqft": "{count} ಚದರ ಅಡಿ",
    "driver.n.rooms.one": "{count} ಬೆಡ್‌ರೂಮ್",
    "driver.n.rooms.other": "{count} ಬೆಡ್‌ರೂಮ್",
    "driver.n.floors.one": "{count} ಮಹಡಿ",
    "driver.n.floors.other": "{count} ಮಹಡಿಗಳು",
    "driver.n.people.one": "{count} ಜನ",
    "driver.n.people.other": "{count} ಜನ",
    "driver.n.meals.one": "{count} ಹೊತ್ತು",
    "driver.n.meals.other": "{count} ಹೊತ್ತು",
    "driver.n.days_week.one": "{count} ದಿನ",
    "driver.n.days_week.other": "{count} ದಿನ",
    "driver.n.hours.one": "{count} ಗಂಟೆ",
    "driver.n.hours.other": "{count} ಗಂಟೆ",
    "driver.n.points.one": "{count} ಪಾಯಿಂಟ್",
    "driver.n.points.other": "{count} ಪಾಯಿಂಟ್‌ಗಳು",
    "driver.thinking": "ಒಂದು ಕ್ಷಣ, ಏನು ಕೇಳಬೇಕು ಎಂದು ಯೋಚಿಸುತ್ತಿದ್ದೇನೆ…",
    "driver.dont_know": "ಗೊತ್ತಿಲ್ಲ",
    "driver.noun.area_sqft": "ಮನೆಯ ವಿಸ್ತೀರ್ಣ",
    "driver.noun.rooms": "ಬೆಡ್‌ರೂಮ್‌ಗಳ ಸಂಖ್ಯೆ",
    "driver.noun.surface": "ಹೊರಗಿನ ಗೋಡೆಗಳು",
    "driver.noun.floors": "ಮಹಡಿಗಳ ಸಂಖ್ಯೆ",
    "driver.noun.house_type": "ಮನೆಯ ಬಗೆ",
    "driver.noun.paint_by": "ಪೇಂಟ್ ಯಾರು ಕೊಳ್ಳುತ್ತಾರೆ",
    "driver.noun.finish": "ಫಿನಿಶ್",
    "driver.noun.people": "ಜನರ ಸಂಖ್ಯೆ",
    "driver.noun.meals": "ಎಷ್ಟು ಹೊತ್ತು ಊಟ",
    "driver.noun.days_week": "ವಾರದ ದಿನಗಳು",
    "driver.noun.frequency": "ಎಷ್ಟು ಸಲ",
    "driver.noun.tasks": "ಯಾವ ಕೆಲಸ",
    "driver.noun.hours": "ದಿನದ ಗಂಟೆಗಳು",
    "driver.noun.vehicle": "ಕಾರು",
    "driver.noun.problem": "ಕೆಲಸ ಏನು",
    "driver.noun.points": "ಪಾಯಿಂಟ್‌ಗಳ ಸಂಖ್ಯೆ",
    "driver.confidence.high": "ಸಾಕಷ್ಟು ಖಚಿತ",
    "driver.confidence.medium": "ಸ್ಥೂಲ ಅಂದಾಜು",
    "driver.confidence.low": "ತುಂಬಾ ಸ್ಥೂಲ ಅಂದಾಜು",
    "driver.confidence_line": "ಎಷ್ಟು ಖಚಿತ: {level}.",
    "driver.spread": "ಇದು ಹೆಚ್ಚಾಗಿ {driver} ಮೇಲೆ ಅವಲಂಬಿತ.",
    "driver.assumed": "ಗೊತ್ತಿರಲಿಲ್ಲ, ಹಾಗಾಗಿ ಊಹಿಸಲಾಗಿದೆ: {drivers}.",
    "driver.basis.gigsync.one": "GigSync ನ {count} ಕೆಲಸ",
    "driver.basis.gigsync.other": "GigSync ನ {count} ಕೆಲಸಗಳು",
    "driver.basis.rate_card": "{city} ದರ ಪಟ್ಟಿ: {sources}",
    "driver.basis_line": "ಆಧಾರ: {parts}.",
    "driver.no_trade": "GigSync ನಲ್ಲಿ {job} ಕೆಲಸದ ದರಗಳು ಇನ್ನೂ ಇಲ್ಲ, ಮತ್ತು GigSync ನಲ್ಲಿ ಯಾರೂ ಈ ಕೆಲಸ ಮಾಡುವುದಿಲ್ಲ.",
};
//# sourceMappingURL=drivers.js.map